/**
 * LotoWheel Modal — Bloqueos (blacklist de TVs/clientes)
 * Se extiende sobre LotowheelModule declarado en lotowheel.js
 */

import { LotowheelModule } from './lotowheel.js';
import { App, Api } from '../../../admin.js';
import { icon } from '../../../utils/icon.js';
import { t } from '../../../services/i18n-admin.js';

Object.assign(LotowheelModule, {
    // ====================================================================
    // BLOQUEOS — Blacklist de TVs/clientes
    // ====================================================================

    async loadBloqueos() {
        const data = await Api.getBloqueos();
        if (!data) return;
        const bloqueos = data.bloqueos || [];
        const tbody = document.getElementById('bloqueosTable');

        if (bloqueos.length === 0) {
            tbody.innerHTML =
                '<tr><td colspan="6" style="text-align:center;padding:40px;color:var(--text-secondary)">' + t('No hay bloqueos activos') + '</td></tr>';
        } else {
            tbody.innerHTML = bloqueos
                .map(b =>
                    '<tr>' +
                    '<td data-label="' + t('Tipo') + '"><span style="padding:4px 8px;background:var(--bg-tertiary);border-radius:4px;font-size:12px;text-transform:uppercase">' + b.tipo + '</span></td>' +
                    '<td data-label="Identificador"><code style="background:var(--bg-tertiary);padding:4px 8px;border-radius:4px">' + b.identificador + '</code></td>' +
                    '<td data-label="' + t('Motivo') + '">' + (b.motivo || '-') + '</td>' +
                    '<td data-label="' + t('Notas') + '">' + (b.notas || '-') + '</td>' +
                    '<td data-label="' + t('Fecha') + '">' + new Date(b.created_at).toLocaleDateString() + '</td>' +
                    '<td data-label=""><button class="btn btn-danger" data-action="lotowheel:deleteBloqueo" data-id="' + b.id + '">' + icon('trash-2') + '</button></td>' +
                    '</tr>'
                )
                .join('');
        }
        // Iconos locales
    },

    openBloqueoModal() {
        App.openModal('modalBloqueo');
        document.getElementById('bloqueoTipo').value = 'tv';
        document.getElementById('bloqueoIdentificador').value = '';
        document.getElementById('bloqueoMotivo').value = 'clonada';
        document.getElementById('bloqueoNotas').value = '';
    },

    async saveBloqueo() {
        const data = {
            tipo: document.getElementById('bloqueoTipo').value,
            identificador: document.getElementById('bloqueoIdentificador').value,
            motivo: document.getElementById('bloqueoMotivo').value,
            notas: document.getElementById('bloqueoNotas').value,
        };

        if (!data.identificador) {
            App.toast(t('Identificador requerido'), 'error');
            return;
        }

        const result = await Api.createBloqueo(data);
        if (result && result.ok) {
            App.toast(t('Bloqueo creado'));
            App.closeModal();
            this.loadBloqueos();
        }
    },

    async deleteBloqueo(id) {
        if (!confirm(t('Desbloquear este registro?'))) return;
        const result = await Api.deleteBloqueo(id);
        if (result && result.ok) {
            App.toast(t('Bloqueo eliminado'));
            this.loadBloqueos();
        }
    },
});
